import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M10.2 3.8a6.4 6.4 0 1 0 0 12.8 6.4 6.4 0 0 0 0-12.8Zm-7.6 6.4a7.6 7.6 0 1 1 13.382 4.933l4.842 4.843a.6.6 0 1 1-.848.848l-4.843-4.842A7.6 7.6 0 0 1 2.6 10.2Z"
      clip-rule="evenodd"
    />
  </svg>
`;
